/** Welcome is shown once per user on this device (localStorage; a server flag can follow). */
const key = (userId: string) => `cm.welcomeSeen.${userId}`;

export function hasSeenWelcome(userId: string): boolean {
  try {
    return window.localStorage.getItem(key(userId)) === "1";
  } catch {
    return false;
  }
}

export function markWelcomeSeen(userId: string): void {
  try {
    window.localStorage.setItem(key(userId), "1");
  } catch {
    /* private mode: showing it again is harmless */
  }
}
